import { Component } from '@angular/core';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { SettingsService } from 'src/app/_services';
import { LxmMessage } from 'src/app/_helpers';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { IOrderDeliverySettings } from 'src/app/models/settings/order-delivery-settings';
import { asArray, DayOfWeek } from 'src/app/enum';

@Component({
  selector: "order-delivery-settings-card",
  templateUrl: './order-delivery-settings.card.html',
  styleUrls: ['./order-delivery-settings.scss']
})
export class OrderDeliverySettingsCardComponent {

  public actionLoading = {} as any;
  public form: FormGroup;

  constructor(
    route: ActivatedRoute,
    private _message: LxmMessage,
    private _settingsService: SettingsService) {

    const orderDeliverySettings = route.snapshot.data.orderDeliverySettingsCard as IOrderDeliverySettings;

    const daysOfWeek = asArray(DayOfWeek);
    const sunday = daysOfWeek.shift();
    if (sunday) {
      daysOfWeek.push(sunday);
    }
    const daysOfWeekAsFormGroup = daysOfWeek.map(x => new FormGroup({
      label: new FormControl(x.label),
      name: new FormControl(x.name),
      isActive: new FormControl(orderDeliverySettings.activeDeliveryDays[x.label])
    }));

    this.form = new FormGroup({
      activeDeliveryDays: new FormArray(daysOfWeekAsFormGroup)
    });

  }

  public get activeDeliveryDays() {
    return <FormArray>this.form.get('activeDeliveryDays');
  }

  public save() {
    const f = this.serializeForm();

    this._settingsService.saveOrderDeliverySettings(f)
      .result(this.form, () => {
        this._message.ok({
          message: 'cards.lexi_market_settings.order_delivery_settings.save_successful'
        });
      }, () => {
        this._message.error({
          message: 'cards.lexi_market_settings.order_delivery_settings.save_failed'
        });
      }, "save", this.actionLoading);
  }

  private serializeForm() {
    const f = this.form.value;

    const activeDeliveryDays = {};
    f.activeDeliveryDays.forEach(x => {
      Object.assign(activeDeliveryDays, {
        [x.label]: x.isActive
      })
    });

    return {
      activeDeliveryDays: activeDeliveryDays
    };
  }
}